import { AuthProvider } from '@context';
import { Outlet } from 'react-router-dom';

export function RootLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}
